import type { FunctionComponent, PropsWithChildren } from 'react';

import { Headline } from '../Typography';
import { Collapsible } from './Collapsible';

type CollapsibleWithHeadlineProps = PropsWithChildren<{
    readonly ariaLabel?: string;
    readonly headline: string;
    readonly isInitiallyExpanded?: boolean;
}>;

export const CollapsibleWithHeadline: FunctionComponent<CollapsibleWithHeadlineProps> = ({
    ariaLabel,
    children,
    headline,
    isInitiallyExpanded,
}) => (
    <Collapsible
        ariaLabel={ariaLabel}
        isInitiallyExpanded={isInitiallyExpanded}
        summary={<Headline variant="h5">{headline}</Headline>}
    >
        {children}
    </Collapsible>
);
